export default "__VITE_ASSET__iLa$m6HM__"